import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { Providers } from "./providers";
import { SessionGate } from "./SessionGate";
import { router } from "./router";
import { Toaster } from "@/ui";
import { removeBootShell } from "@/lib/boot-shell";

export function App() {
  // The static shell from index.html hands over here: React has committed its
  // first render, so removing it cannot produce an empty frame.
  useEffect(() => {
    removeBootShell();
  }, []);

  return (
    <Providers>
      <SessionGate>
        <RouterProvider router={router} />
      </SessionGate>
      <Toaster />
    </Providers>
  );
}
